import React from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

const MarginModal = (props) => {
  const {
    onClose,
  } = props;

  return (
    <Modal
      show
      onHide={onClose}
      backdrop
      centered
      className="options-submit-modal"
    >
      <div className="options-submit-modal-div">
        <Modal.Header closeButton id="options-modal-title">
          <h1 id="page-header" className="h1_secondary">
            Cash vs. Margin Accounts
          </h1>
        </Modal.Header>
        <Modal.Body className="options-submit-modal-body">
          <p className="panel-question">
            In cash-only accounts, customer trades must be fully paid for on or before the settlement date,
            which is the day after the trade date for options transactions and three days after the trade date
            for stock trades. Investors with cash-only accounts cannot initiate or hold uncovered short positions.
            <br /><br />
            In a margin account, customers are permitted to borrow money from the firm to fund transactions.
            Margin accounts may also utilize acceptable collateral to finance requirements and debit balances.
            Margin accounts may also (if approved) hold complex positions, including uncovered short positions.
            Margin should only be used by sophisticated investors who understand that losses can exceed their
            original investment.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="text-center">
            <button
              type="button"
              className="btn btn-raised btn-default do_capitalize"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </Modal.Footer>
      </div>
    </Modal>
  );
};

MarginModal.propTypes = {
  onClose: PropTypes.func,
};

export default MarginModal;
